import VueCookies from 'vue-cookies'
import axios from 'axios'
import store from '../storages'
import jwtDecode from 'jwt-decode'

export default {
  computed: {
    isAuthorized () {
      return this.$store.getters.value('isAuthorized')
    }
  },
  methods: {
    clearCookies () {
      // return true
      axios.defaults.headers.common['Authorization'] = ''
      store.dispatch('SET_VALUE', {key: 'isAuthorized', value: false}) // ZZZZ
      if (VueCookies.remove('refresh') !== null) {
        VueCookies.remove('refresh')
      }
      if (VueCookies.remove('access') !== null) {
        VueCookies.remove('access')
      }
      this.clearUserInfoMix()
    },
    getRefreshToken (login, pass) {
      return axios.post(`${this.$store.getters.value('iamHost')}/auth/api/v1/session/`, {
        username: login,
        password: pass
      })
    },
    getAccessToken () {
      axios.defaults.headers.common['Authorization'] = 'JWT ' + VueCookies.get('refresh')
      return axios.post(`${store.getters.value('iamHost')}/auth/api/v1/authorize/`, {})
    },
    setUserInfoMix (tkn) {
      let _tkn = tkn
      if (tkn === undefined) {
        _tkn = VueCookies.get('access')
      }
      let info = jwtDecode(_tkn)
      store.dispatch('SET_VALUE', {key: 'email', value: info.email})
      store.dispatch('SET_VALUE', {key: 'permissions', value: info.scopes})
      // console.log(info.scopes)
    },
    checkHavePermissionMix (permis, regionCode) {
      let permissions = store.getters.value('permissions')
      if (regionCode === undefined || regionCode === false || regionCode === null) { // если право не привязано к региону(такие как просмотр аналитики)
        return permissions.indexOf(permis) !== -1
      } else { // если привязано к региону
        if (regionCode === '*') { // если регион равен "*", то проверяем все
          let have = false
          for (let i = 1; i < 37; i++) {
            let code = (i < 10) ? '0' + i : i
            let prmisWithCode = permis + code
            if (permissions.indexOf(prmisWithCode) !== -1) {
              have = true
              break
            }
          }
          return have
        } else {
          let prmisWithCode = permis + regionCode
          return permissions.indexOf(prmisWithCode) !== -1
        }
      }
    },
    clearUserInfoMix () {
      store.dispatch('SET_VALUE', {key: 'email', value: ''})
      store.dispatch('SET_VALUE', {key: 'permissions', value: []})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/authMix.js